import apiInstance from '../../backend-api.setup'
import { ApiPathConfig } from '../../../config/ApiPathConfig'

export const getUsersService = () => apiInstance.get(ApiPathConfig.USERS)
